/**
 * API configuration constants for TriviYolo Web
 * Supports multiple deployment environments (local, staging, production)
 */

// Environment detection
const ENV = import.meta.env.VITE_APP_ENV || 'localhost';

// Environment-specific configuration
const ENV_CONFIG = {
  local: {
    apiBaseUrl: 'https://localhost:5002',
    apiScheme: 'https',
    apiHost: 'localhost',
    apiPort: '5002'
  },
  staging: {
    apiBaseUrl: 'https://api-staging.triviyolo.com',
    apiScheme: 'https',
    apiHost: 'api-staging.triviyolo.com',
    apiPort: '443'
  },
  production: {
    apiBaseUrl: 'https://api.triviyolo.com',
    apiScheme: 'https',
    apiHost: 'api.triviyolo.com',
    apiPort: '443'
  }
};

// Get current environment config with environment variable overrides
const currentConfig = ENV_CONFIG[ENV as keyof typeof ENV_CONFIG] || ENV_CONFIG.local;

// API base URL with environment variable override
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || currentConfig.apiBaseUrl;

// API components for flexible usage
export const API_SCHEME = import.meta.env.VITE_API_SCHEME || currentConfig.apiScheme;
export const API_HOST = import.meta.env.VITE_API_HOST || currentConfig.apiHost;
export const API_PORT = import.meta.env.VITE_API_PORT || currentConfig.apiPort;

// SignalR hub URL
export const GAME_HUB_URL = `${API_SCHEME}://${API_HOST}${API_PORT !== '443' ? `:${API_PORT}` : ''}/gamehub`;

// Environment helper
export const isProduction = ENV === 'production';
export const isStaging = ENV === 'staging';
export const isDevelopment = ENV === 'local';
